export default __webpack_public_path__ + "images/b8bc4d2005e766749804fcb819c5104e.webp";